<template>
  <div class="flex">
    <icon-tab-button
      :icon="IconFormulaView"
      role="formula-view-select"
      class="pt-3 pr-2 pb-0 pl-4"
      :class="{
        'bg-disabled': modelValue === CustomAttributeTypeOption.formula,
      }"
      left-end
      :active="modelValue === CustomAttributeTypeOption.formula"
      @click="emit('update:modelValue', CustomAttributeTypeOption.formula)"
    />
    <icon-tab-button
      :icon="IconDataServices"
      role="api-view-select"
      class="pt-3 pr-2 pb-0 pl-4"
      :class="{ 'bg-disabled': modelValue === CustomAttributeTypeOption.api }"
      right-end
      :active="modelValue === CustomAttributeTypeOption.api"
      @click="emit('update:modelValue', CustomAttributeTypeOption.api)"
    />
  </div>
</template>

<script lang="ts" setup>
import { CustomAttributeTypeOption } from "@/enums/customAttributes";

import IconDataServices from "@/components/icons/IconDataServices.vue";
import IconFormulaView from "@/components/icons/IconFormulaView.vue";
import IconTabButton from "@/components/ui/buttons/IconTabButton.vue";

defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits<{
  (e: "update:modelValue", value: CustomAttributeTypeOption): void;
}>();
</script>
